import { callAsync } from "./officeAsync";

export interface LabelNode {
  id: string;
  name: string;
  children?: LabelNode[] | null;
}

/**
 * Returns the names from the matching label up to its top-level parent (e.g. ["Internal", "Company"]),
 * or [] when the id isn't in the catalog.
 */
export function labelNamesForId(catalog: LabelNode[], id: string): string[] {
  for (const node of catalog) {
    if (node.id.toLowerCase() === id.toLowerCase()) {
      return [node.name];
    }
    const inChildren = labelNamesForId(node.children ?? [], id);
    if (inChildren.length > 0) {
      return [...inChildren, node.name];
    }
  }
  return [];
}

/**
 * Names of the sensitivity label applied to the message, [] when the message has no label, or null when
 * it can't be determined (unsupported, labels not enabled, unknown label id, or any error; fail open, FR-19).
 * Requires Mailbox 1.13 + Purview labels.
 */
export async function getLabelNames(item: Office.MessageCompose): Promise<string[] | null> {
  try {
    if (!Office.context.requirements.isSetSupported("Mailbox", "1.13") || !item.sensitivityLabel) {
      return null;
    }
    const catalogApi = Office.context.sensitivityLabelsCatalog;
    const enabled = await callAsync<boolean>((cb) => catalogApi.getIsEnabledAsync(cb));
    if (!enabled) {
      return null;
    }
    const labelId = await callAsync<string>((cb) => item.sensitivityLabel.getAsync(cb));
    if (labelId === undefined) {
      return null;
    }
    if (!labelId) {
      return [];
    }
    const catalog = await callAsync<Office.SensitivityLabelDetails[]>((cb) => catalogApi.getAsync(cb));
    const names = catalog ? labelNamesForId(catalog, labelId) : [];
    return names.length > 0 ? names : null;
  } catch {
    return null;
  }
}
